var makeString = require('./makeString');

module.exports = function escapeRegExp(str) {
  return makeString(str).replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/underscore.string/helper/escapeRegExp.js
// module id = 3tf0
// module chunks = 0